module.exports = __webpack_public_path__ + "img/172620.da8b6d09.png";